<img
    alt="Logo"
    src="assets/images/ng-morph.png"
    class="logo"
/>
ng-morph
<img
    alt="by T-Bank"
    src="assets/images/by.svg"
    class="by"
/>
